import { Tour } from "../TourProvider.types";

export const TourOrganizationManageUsage: Tour = {
  name: "Resource usage and project management",
  pages: ["organizationUsage"],
  conditions: { isOrgAdmin: true, isPersonalSpace: false },
  description:
    "View subscription details and see how resources are being used.",
  steps: [
    {
      anchorId: "usage-section",
      title: "See usage at a glance",
      content:
        "Subscription details shows you the total amount of active storage, archived storage, compute credits, and downloads in your organization. The bars indicate how much of your total subscription allowances you have consumed to date.",
    },
    {
      anchorId: "projects-admin-table",
      title: "View usage by projects",
      content:
        "The projects table lets you view your organization usage by each project. You can sort the table by any of the columns.",
    },
    {
      anchorId: "project-access-menu",
      title: "Modify Project access",
      content:
        "Projects that aren't clickable mean that your user has not been granted access. However, as an Org Admin, you can modify any Project access in this view by clicking the gear icon and selecting 'Modify Access'.",
    },
  ],
};
